import { getAccountImpTransactions, getAccountTransactionSummary, getAccountTransactions } from "../types/account_transactions_types";


export const getAccountTransactionsRequest = (payload) => ({
    type: getAccountTransactions.GET_ACCOUNT_TRANSACTIONS_REQUEST,
    payload,
});
export const getAccountTransactionsSuccess = (payload) => ({
    type: getAccountTransactions.GET_ACCOUNT_TRANSACTIONS_SUCCESS,
    payload,
});
export const getAccountTransactionsError = (payload) => ({
    type: getAccountTransactions.GET_ACCOUNT_TRANSACTIONS_ERROR,
    payload,
});

export const getAccountImpTransactionsRequest = (payload) => ({
    type: getAccountImpTransactions.GET_ACCOUNT_IMP_TRANSACTIONS_REQUEST,
    payload,
});
export const getAccountImpTransactionsSuccess = (payload) => ({
    type: getAccountImpTransactions.GET_ACCOUNT_IMP_TRANSACTIONS_SUCCESS,
    payload,
});
export const getAccountImpTransactionsError = (payload) => ({
    type: getAccountImpTransactions.GET_ACCOUNT_IMP_TRANSACTIONS_ERROR,
    payload,
});

export const getAccountTransactionSummaryRequest = (payload) => ({
    type: getAccountTransactionSummary.GET_ACCOUNT_TRANSACTIONS_SUMMARY_REQUEST,
    payload,
});
export const getAccountTransactionSummarySuccess = (payload) => ({
    type: getAccountTransactionSummary.GET_ACCOUNT_TRANSACTIONS_SUMMARY_SUCCESS,
    payload,
});
export const getAccountTransactionSummaryError = (payload) => ({
    type: getAccountTransactionSummary.GET_ACCOUNT_TRANSACTIONS_SUMMARY_ERROR,
    payload,
});